// @ts-expect-error not migrated to TS yet
import isInReviewOrBlocked from 'content-label-lib/utils/isInReviewOrBlocked';
// @ts-expect-error not migrated to TS yet

// @ts-expect-error not migrated to TS
import { setUserAttribute } from 'email-management-lib/refactor/actions/userAttributes';
import getTagColor from 'ContentComponents/utils/getContentState';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import EmailModel from 'email-management-lib/Shared/models/EmailModel';
import { openEmailDetailsPanel } from 'email-management-lib/refactor/actions/manage/frameworkTable';
import EmailLinkWithTooltip from 'email-management-lib/refactor/components/manage/frameworkTable/components/EmailLinkWithTooltip';
import { useInsightPolarity } from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useInsightPolarity';
import DeletedViewHoverActions from 'email-management-lib/refactor/components/manage/frameworkTable/hoverActions/DeletedViewHoverActions';
import EmailHoverActions from 'email-management-lib/refactor/components/manage/frameworkTable/hoverActions/EmailHoverActions';
import { HAS_SEEN_EMAIL_INSIGHTS } from 'email-management-lib/refactor/constants/userAttributes';
import { getPrimaryActionTooltipOpen } from 'email-management-lib/refactor/selectors/manage/table';
import { getShouldShowPortalMigrationWarning, mayBeRenderMigrationWarning } from 'email-management-lib/refactor/utils/portalMigration';
import { getIsDeletedView } from 'email-management-lib/refactor/utils/views';
import { getCustomTabId } from 'framework-asset-preview-lib/utils/tabs';
import ListingLibLabelCell from 'framework-listing-lib/table/ListingLibLabelCell';
import { TInsightIcon } from 'messaging-publishing-lib/Insights/components/EmailInsights/InsightIcon';
import { INSIGHTS_PANEL_KEY } from 'messaging-publishing-lib/Insights/constant/EmailInsightsPanel';
import { trackInsightsIconClickInteraction } from 'messaging-publishing-lib/utils/tracking';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { ReportsIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';

/**
 * `border` is critical to give the element
 * padding so the coaching tip is not completely
 * covering the icon.
 *
 * `cursor` needs to be set here to avoid the `?`
 * cursor from being shown when hovering in the
 * transparent border.
 */
// @bend-expect trellis-tokenized
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InsideRightPaddingOfCell = styled.div.withConfig({
  displayName: "EmailTitleCell__InsideRightPaddingOfCell",
  componentId: "sc-1c5zlp-0"
})(["position:absolute;top:0px;right:4px;border:8px solid transparent;cursor:initial;"]);
function EmailTitleCell({
  canCreateClassicEmail,
  crmObject,
  emailTypesAuthedFor,
  tdProps,
  reviewContext,
  isEligibleForPortalMigration,
  portalMigrationHoistingHublet,
  portalMigrationStartDate,
  portalMigrationEndDate
}) {
  const primaryActionTooltipOpen = useSelector(getPrimaryActionTooltipOpen);
  const dispatch = useDispatch();
  const maybeInsightPolarity = useInsightPolarity({
    crmObject
  });
  const emailObject = EmailModel.from(crmObject);
  const emailId = emailObject.id || 0;
  const emailType = emailObject.emailType || '';
  const emailPublishDate = Number(emailObject.publishDate || '0');
  const isArchived = emailObject.archived;
  const shouldShowPortalMigrationWarning = getShouldShowPortalMigrationWarning({
    isEligibleForPortalMigration,
    portalMigrationEndDate,
    portalMigrationStartDate,
    emailPublishDate,
    emailType
  });
  const aiInsightsTab = getCustomTabId(INSIGHTS_PANEL_KEY);
  const onClickInsightIcon = useCallback(() => {
    trackInsightsIconClickInteraction(crmObject);
    dispatch(setUserAttribute(HAS_SEEN_EMAIL_INSIGHTS, true));
    dispatch(openEmailDetailsPanel({
      crmObject,
      tab: aiInsightsTab
    }));
  }, [dispatch, crmObject, aiInsightsTab]);
  const migrationWarning = useMemo(() => {
    if (!emailObject.isScheduled()) {
      return null;
    }
    return mayBeRenderMigrationWarning({
      portalMigrationHoistingHublet,
      portalMigrationStartDate,
      shouldShowPortalMigrationWarning,
      emailType
    });
  }, [emailObject, emailType, portalMigrationHoistingHublet, portalMigrationStartDate, shouldShowPortalMigrationWarning]);
  const isDeletedView = getIsDeletedView();
  const renderCellBody = useCallback(({
    isTooltip
  } = {
    isTooltip: false
  }) => {
    const status = emailObject.wasCanceledForAbuse() || emailObject.wasForciblyCancelled() || isInReviewOrBlocked(emailId, reviewContext) ? 'ERROR' : emailObject.state;
    const tagUse = getTagColor(status);
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      blockSize: "40px",
      children: [migrationWarning, isDeletedView ? /*#__PURE__*/_jsx("span", {
        "data-test-id": "plain-email-name",
        children: emailObject.name
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(StatusDot, {
            hollow: isArchived,
            use: tagUse
          })
        }), /*#__PURE__*/_jsx(EmailLinkWithTooltip, {
          canCreateClassicEmail: canCreateClassicEmail,
          emailObject: emailObject,
          emailTypesAuthedFor: emailTypesAuthedFor
        }), maybeInsightPolarity !== null && !isTooltip && /*#__PURE__*/_jsx(TInsightIcon, {
          polarity: maybeInsightPolarity,
          Icon: ReportsIcon,
          onClick: onClickInsightIcon,
          Wrapper: InsideRightPaddingOfCell
        })]
      })]
    });
  }, [canCreateClassicEmail, emailId, emailObject, emailTypesAuthedFor, isArchived, isDeletedView, maybeInsightPolarity, migrationWarning, onClickInsightIcon, reviewContext]);
  const listingLabelClassNames = maybeInsightPolarity !== null ? 'p-right-10' : "";
  const hoverContentProps = useMemo(() => {
    return primaryActionTooltipOpen.open === true && primaryActionTooltipOpen.emailId === emailId ? {
      open: primaryActionTooltipOpen.open
    } : undefined;
  }, [emailId, primaryActionTooltipOpen.emailId, primaryActionTooltipOpen.open]);
  const hoverContent = useMemo(() => {
    return isDeletedView ? /*#__PURE__*/_jsx(DeletedViewHoverActions, {
      crmObject: crmObject
    }) : /*#__PURE__*/_jsx(EmailHoverActions, {
      crmObject: crmObject
    });
  }, [crmObject, isDeletedView]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(ListingLibLabelCell, Object.assign({
      hoverContentProps: hoverContentProps,
      hoverContent: hoverContent,
      className: listingLabelClassNames,
      tooltip: renderCellBody({
        isTooltip: true
      })
    }, tdProps, {
      "data-test-id": "email-title-cell",
      children: renderCellBody()
    }))
  });
}
export default EmailTitleCell;